import { getConfig } from '@/config/config';
import { NetworkEnum } from '@/config/config.types';
import { getLogger } from '@/utils/loglevel';
import {
  ProtocolProfile,
  GuardianRecord,
  OracleAPI,
} from '@ducat-unit/client-sdk';
import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  DefaultError,
} from '@tanstack/react-query';
import { QueryKeys } from './query-keys';

type QueryOptionsParam = Omit<UseQueryOptions, 'queryKey' | 'queryFn'>;

const logger = getLogger('useGuardRecords', 'debug');

function getGuardianRecordsFromConfig(network: NetworkEnum) {
  const config = getConfig(network);

  return config.guardians.map((guard) => ({
    url: guard.guardianUrl,
    pub: config.guardianPubkey,
  }));
}

export function useGuardRecords(
  {
    network,
    contract,
  }: { network: NetworkEnum; contract?: ProtocolProfile | null },
  options: QueryOptionsParam
): UseQueryResult<GuardianRecord[], DefaultError> {
  // @ts-ignore
  return useQuery({
    queryKey: [QueryKeys.guardRecords, network],
    queryFn: async () => fetch_guard_records({ contract, network }),
    staleTime: Infinity,
    initialData: getGuardianRecordsFromConfig(network),
    retry: false,
    ...options,
  });
}

async function fetch_guard_records({
  network,
  contract,
}: {
  network: NetworkEnum;
  contract?: ProtocolProfile | null;
}): Promise<GuardianRecord[]> {
  logger.debug(`- adding guards from network config! ${network}`);

  return getGuardianRecordsFromConfig(network);

  // // Check if contract data exists.
  // if (contract === null) {
  //   // toast("Failed to fetch guardian members: contract data is null");
  //   throw new Error('failed to fetch guardian members: contract data is null');
  // } else {
  //   // Fetch the guardian records from the ord server.
  //   const address = contract.groups.guard.adr;
  //   let res;

  //   try {
  //     res = await OracleAPI.group.fetch_rand_guardian_host(
  //       networkConfig.esploraUrl,
  //       networkConfig.ordUrl,
  //       address
  //     );
  //   } catch (e) {
  //     logger.debug(`Failed to fetch_guard_records for ${network}`, e);
  //     res = {};
  //   }

  //   if (res.ok && res.data) {
  //     return [res.data];
  //   } else {
  //     logger.debug(`- adding guards from network config! ${network}`);
  //     const config = getConfig(network);
  //     return config.guardians.map((guard) => ({
  //       url: guard.guardianUrl,
  //       pub: config.guardianPubkey,
  //     }));
  //   }
  // }
}
